export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/Illustration.e32388d.svg";